import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../styles/style.css";
import "../styles/PalmsSite.css";
import HeaderSerene from "../components/PlamsHeader";
import SereneLogo from "../assets/palms-images/palms-logo-web.png";
import HeroPalms from "../components/HeroPalms"
import ConstructionProgress from "../components/ConstructionProgressPalms"
import AboutSectionTwo from "../components/AboutPalms"
import AboutSectionThree from "../components/AboutPalms1"
import HighlightsSection from "../components/HighlightsSerene"
import LegendsSections from "../components/MasterPlanWithLegend"
import MasterPlanPreview from "../components/PalmsMasterPlanPreview"
import LocationSection from "../components/LocationPalms"
import ClubHouseSection from "../components/ClubHousePalms"
import ApprovedBanks from "../components/ApprovedBanks"
import ContactSection from "../components/ContactPalms"
import SpecificationsSection from "../components/SpecificationSerene"
import SpecificationsSerene from "../components/SpecificationAccordion"
import GalleryPalms from "../components/GalleryPalms";
import PalmsMasterPlanLegends from "../components/PalmsMasterPlanWithLegend";
import PalmsSpecificationAccordion from "../components/PalmsSpecificationAccordion";


function PalmsSite() {


    return (
        <section id="home-palms">
            {/* Header visible only in home */}
            <HeaderSerene />
            <HeroPalms />
            <AboutSectionTwo />
            <AboutSectionThree />
            <MasterPlanPreview />

            {/* <HighlightsSection /> */}
            <ClubHouseSection />
            <GalleryPalms />

            <PalmsMasterPlanLegends />

            {/* <SpecificationsSection /> */}
            <LocationSection />
            <ConstructionProgress />

            {/* <SpecificationsSerene /> */}

            <PalmsSpecificationAccordion />

            <ApprovedBanks />
            <ContactSection />




        </section>
    );
}

export default PalmsSite;
